// extracted by mini-css-extract-plugin
export default {"component":"NavigationBlock__component--slots-fTl1b","list":"NavigationBlock__list--slots-F600y","item":"NavigationBlock__item--slots-cYi9S"};